import FilterExpressionService from '../../../services/filter.expression.service';
import _, { filter } from 'lodash';
import Signals from 'signals';

function isEmpty(filters) {
    if (filters && filters.filterGroups && filters.filterGroups.length > 0) {
        // if there is 1 filter group with an empty or non-existant "filters" array, the filter is empty
        if (filters.filterGroups.length === 1 && (!filters.filterGroups[0].filters || filters.filterGroups[0].filters.length === 0)) {
            return true;
        }
        if (filters.filterGroups.length === 1 && filters.filterGroups[0].filters.length === 1) {
            // a filter with only an id property is, for all intents and purposes, empty
            let filterKeys = Object.keys(filters.filterGroups[0].filters[0]);
            if (filterKeys.length === 1 && filterKeys[0] === 'id') {
                return true;
            }
        }
        return false;
    }
    return true;
}

function isIncomplete(filter) {
    let type = filter.type;
    // A filter is incomplete if it has no value or an empty value
    return !filter.value && (type !== 'is empty' && type !== 'is not empty' && type !== 'empty' && type !== 'not empty');
}

class FilterModel {
    /**
     * @param enableCaching when {@code true}, the filters are cached in the sessionStorage
     * @param cacheKey the key that identifies this model's filters. This is required if {@code enableCaching} is true.
     * @constructor
     */
    constructor(enableCaching, cacheKey, activeFilters) {
        var self = this;
        self.activeFilterExpression = {filterGroups: [{filters: [], operator: 'and'}], operator: 'and'}; // default to an empty filter expression
        self.availableFilters = null;
        self.metadata = null;
        self.activeFiltersUpdated = new Signals.Signal();
        self.availableFiltersUpdated = new Signals.Signal();
        self.cachingEnabled = enableCaching;
        self.cacheKey = cacheKey;
        if (activeFilters) {
            if (typeof activeFilters === 'array') {
                self.activeFilterExpression = convertOldFilters(activeFilters);
            } else {
                self.activeFilterExpression = activeFilters;
            }
        }
    }

    convertOldFilters(filters) {
      return FilterExpressionService.convertOldFilters(filters);
    }

    getActiveFilters() {
        var self = this;

        // If the page doesn't have any activeFilterExpression but we have a cachedFilter,
        // let the cachedFilter be the default.
        if (self.cachingEnabled === true) {
            var cachedFilters = JSON.parse(sessionStorage.getItem(self.cacheKey));
            if ((_.isNil(self.activeFilterExpression) || self.isEmpty()) && (!_.isNil(cachedFilters) && !isEmpty(cachedFilters))) {
            // if ((_.isNil(self.activeFilterExpression) || self.isEmpty()) && (!_.isNil(cachedFilters) && cachedFilters.filterGroups)) {
                self.activeFilterExpression = cachedFilters;
            }
        }
        return _.cloneDeep(self.activeFilterExpression);
    }

    /**
     * Returns the active filters minus the incomplete filters.
     * 
     **/
    getActiveFiltersForQuery() {
        let activeFilters = this.getActiveFilters();
        // Remove empty filters
        if (activeFilters.filterGroups && activeFilters.filterGroups.length > 0) {
            activeFilters.filterGroups = activeFilters.filterGroups.filter(group => {
                group.filters = group.filters.filter(filter => !isIncomplete(filter));
                return group.filters.length > 0;
            });
        }
        return activeFilters;
    }

    getActiveFiltersString() {
        let filterExpression = this.getActiveFiltersForQuery();
        return FilterExpressionService.getFilterStringFromFilterExpression(filterExpression);
    }

    getActiveFiltersDisplay() {
        let filterExpression = this.getActiveFilters();
        return FilterExpressionService.getFilterDisplayStringFromFilterExpression(filterExpression);
    }

    getAvailableFilters() {
        var self = this;
        return _.cloneDeep(self.availableFilters);
    }

    getDatasetMetadata() {
        return _.cloneDeep(this.metadata);
    }

    getFiltersFromString(filterUrl) {
        return FilterExpressionService.getFiltersFromString(filterUrl, this.getDatasetMetadata().columns);
    }

    /**
     * Returns true if no filters are available.
     */
    isEmpty() {
        let filters = this.activeFilterExpression;
        return isEmpty(filters);
    }

    /**
     * Sets the filters selected so far by the end-user.
     * @param filterExpression a filter expression object
     */
    setActiveFilters(filterExpression) {
        var self = this;

        function areFiltersEquivalent(filterA, filterB) {
            let filterStringFromFilterExpressionA = FilterExpressionService.getFilterStringFromFilterExpression(filterA);
            let filterStringFromFilterExpressionB = FilterExpressionService.getFilterStringFromFilterExpression(filterB);
            return filterStringFromFilterExpressionA === filterStringFromFilterExpressionB;
        }

        let diff = !areFiltersEquivalent(filterExpression, self.activeFilterExpression);
        self.activeFilterExpression = _.cloneDeep(filterExpression);
        if (self.cachingEnabled === true) {
            sessionStorage.setItem(self.cacheKey, JSON.stringify(filterExpression));
        }
        if (diff) {
            self.activeFiltersUpdated.dispatch();
        } // todo only fire this on a change
    }

    setAvailableFilters(availableFilters) {
        var self = this;
        self.availableFilters = _.cloneDeep(availableFilters);
        self.availableFiltersUpdated.dispatch();
    }

    setDatasetMetadata(metadata) {
        var self = this;
        self.metadata = _.cloneDeep(metadata);
    }
}


export default FilterModel;
